'use strict';

var React = require('react');

var SvgLocationsMinor = function SvgLocationsMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-8c-3.31 0-6 2.87-6 6.4 0 6 5.4 9.35 5.63 9.49.11.07.24.11.37.11s.26-.04.37-.11c.23-.14 5.63-3.49 5.63-9.49 0-3.53-2.69-6.4-6-6.4z"
  }));
};

exports.SvgLocationsMinor = SvgLocationsMinor;
